import { DialogConfig, BlockerConfig, IStaff } from '@/interfaces';

export class UserInterface {
	private _v: any;
	
	constructor(vue: any) {
    this._v = vue;
	}

  public QuickConfirm(
    title: string,
    text: string,
    callback: (ok:boolean) => void = null
  ) {
    var dc = new DialogConfig();
    dc.Title = title;
		dc.Text = text;
		dc.Callback = callback;

		this.Confirm(dc);
  }

  public Confirm(cfg: DialogConfig) {
    this._v.$store.dispatch("AppModule/setDialog", cfg);
	}
	

  public QuickAlert(
    title: string,
    text: string,
    callback: () => void = null
  ) {
    var dc = new DialogConfig();
    dc.Title = title;
		dc.Text = text;
		dc.ShowCancel = false;

		dc.Callback = ()=>{
			if (callback)callback();
		};

		this.Confirm(dc);
  }


	public SnacSuccess(msg: string){
		this.Snac(msg, "success");
	}

	public SnacError(msg: string){
		this.Snac(msg, "error");
	}

	public Snac(msg: string, status: string){
		this._v.$store.dispatch("AppModule/setSnackbar", {
      status: status,
      message: msg,
    });
	}

	public TurnBlockerOn(){
		this.TurnBlocker_(true);
	}
	public TurnBlockerOff(){
		this.TurnBlocker_(false);
	}
	private TurnBlocker_(viz: boolean){
		var cfg = new BlockerConfig();
		cfg.Show = viz;
    this._v.$store.dispatch("AppModule/setBlocker", cfg);
	}


	public RefreshTimestampUsers(){
		/// USED TO DISPATCH A NOTIFICATION, SO COMPONENTS WITH USERS
		/// SHOULD TRIGGER A REFRESH TO SHOW UPDATED RESULTS.
    this._v.$store.dispatch("AppModule/refreshTimestampUsers");
	}

	public RefreshTimestampInvoices(){
		/// USED TO DISPATCH A NOTIFICATION, SO COMPONENTS WITH INVOICES
		/// SHOULD TRIGGER A REFRESH TO SHOW UPDATED RESULTS.
    this._v.$store.dispatch("AppModule/refreshTimestampInvoices");
	}


	public RefreshTimestampCustomers(){
		/// USED TO DISPATCH A NOTIFICATION, SO COMPONENTS WITH CUSTOMERS
		/// SHOULD TRIGGER A REFRESH TO SHOW UPDATED RESULTS.
    this._v.$store.dispatch("AppModule/refreshTimestampCustomers");
	}


	public IntakeStaffStatusChange(s: IStaff){
		// /// USED TO DISPATCH A NOTIFICATION, SO COMPONENTS WITH CUSTOMERS
		// /// SHOULD TRIGGER A REFRESH TO SHOW UPDATED RESULTS.
    this._v.$store.dispatch("AppModule/setStaffStatus", s);
	}



	

}